// The server answers 402 `ai_actions_exhausted` when a Free user's weekly AI
// actions can't cover a generation request. This is the bridge from the
// request layer (no React) to the one upgrade dialog mounted by
// UpgradeProvider: the request layer reports, the provider listens.

export const AI_ACTIONS_EXHAUSTED = "ai_actions_exhausted";

export interface OutOfActionsInfo {
  /** Server-written, user-facing sentence ("You have no AI actions available this week."). */
  message: string;
  remaining?: number;
  requested?: number;
  limit?: number;
  resetsAt?: string;
}

type Listener = (info: OutOfActionsInfo) => void;
const listeners = new Set<Listener>();

export function onOutOfActions(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function reportOutOfActions(info: OutOfActionsInfo): void {
  listeners.forEach((l) => l(info));
}

/** Tell the user, via the upgrade dialog, that creating a test is blocked until they upgrade or the week resets. */
export function reportNoActionsLeft(limit: number, resetsAt: Date): void {
  reportOutOfActions({
    message: "You have no AI actions available this week.",
    remaining: 0,
    limit,
    resetsAt: resetsAt.toISOString(),
  });
}

const num = (v: unknown) => (typeof v === "number" ? v : undefined);

export function outOfActionsInfo(message: string, body?: Record<string, unknown>): OutOfActionsInfo {
  return {
    message,
    remaining: num(body?.remaining),
    requested: num(body?.requested),
    limit: num(body?.limit),
    resetsAt: typeof body?.resetsAt === "string" ? body.resetsAt : undefined,
  };
}
